// client/src/components/marketer/project/StepBox.js
import React from 'react';

// 시안 .step 구조: 번호(완료 시 ✓) + 제목 + 요약 + 우측 버튼
// props 시그니처 유지: { title, actionLabel, onAction, filled, valueText }
// 스텝 번호는 title 앞의 "N. " 접두를 파싱해 표시 (렌더 전용)
export default function StepBox({ title, actionLabel, onAction, filled, valueText }) {
  const m = /^(\d+)\.\s*(.*)$/.exec(title || '');
  const num = m ? m[1] : '';
  const label = m ? m[2] : title;

  return (
    <div className={`step${filled ? ' is-done' : ''}`}>
      <span className="step__num">{filled ? '✓' : num}</span>
      <div className="step__txt">
        <b>{label}</b>
        {filled && valueText ? <span>{valueText}</span> : null}
      </div>
      <button
        type="button"
        onClick={onAction}
        className={`mb-btn mb-btn-sm ${filled ? 'mb-btn-secondary' : 'mb-btn-primary'}`}
        style={{ flexShrink: 0 }}
      >
        {filled ? '수정하기' : actionLabel}
      </button>
    </div>
  );
}
